var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13 24c6.0165 0 11-4.9835 11-11 0-6.01651-4.9948-11-11.0114-11-6.00511 0-10.9886 4.98349-10.9886 11 0 6.0165 4.98349 11 11 11zm0-1.9412c-5.01754 0-9.03612-4.0299-9.03612-9.0588s4.00722-9.05882 9.02472-9.05882c5.0289 0 9.0589 4.02992 9.0702 9.05882.0114 5.0289-4.0299 9.0588-9.0588 9.0588zm-.227-6.8679c.5562 0 .8968-.3405.9081-.7719 0-.0341 0-.0795 0-.1249.0114-.5903.3746-.9649 1.1012-1.4417 1.0557-.6924 1.7708-1.3168 1.7708-2.5882 0-1.78226-1.5892-2.76988-3.4396-2.76988-1.8503 0-3.0763.86275-3.38285 1.86172-.05676.18163-.09081.35191-.09081.53354 0 .49952.38596.78332.77196.78332.3746 0 .613-.1703.8173-.4428l.1816-.23836c.3746-.62435.9195-.96491 1.612-.96491.9422 0 1.5552.54489 1.5552 1.32817 0 .7152-.4427 1.0671-1.3736 1.7141-.7719.5336-1.3395 1.0898-1.3395 2.1229v.1248c0 .579.3179.8741.9082.8741zm-.0227 3.2353c.647 0 1.1919-.4881 1.1919-1.1352 0-.647-.5335-1.1352-1.1919-1.1352-.6471 0-1.192.4995-1.192 1.1352s.5563 1.1352 1.192 1.1352z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.30063473.svg";
export { ForwardRef as ReactComponent };